import { render } from "./MiCheckbox.vue?vue&type=template&id=3397d962&scoped=true"
import script from "./MiCheckbox.vue?vue&type=script&lang=js"
export * from "./MiCheckbox.vue?vue&type=script&lang=js"

import "./MiCheckbox.vue?vue&type=style&index=0&id=3397d962&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3397d962"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
